const url = new URL(window.location.href);
let bypassApi = () => {
  if (url.searchParams.get('token')) {
    if (url.searchParams.get('is_webview') == 0) return process.env.VUE_APP_API_URL
    const config = {
      apiBase: url.searchParams.get('api_base'),
      platform: url.searchParams.get('platform'),
      webBase: url.searchParams.get('web_base'),
    }
    return config.apiBase + '/';
  }
  else return process.env.VUE_APP_API_URL
}
// const BASE_URL = process.env.NODE_ENV == "production" ? process.env.VUE_APP_API_URL : bypassApi();
const BASE_URL = bypassApi();

const AUTH = `${BASE_URL}auth/`;
const MASTER_DATA = `${BASE_URL}masterData/`;

const routeGroup = {
  meta: `${MASTER_DATA}meta/`,
  konsumen: `${MASTER_DATA}customer/`,
  pembatalan: `${MASTER_DATA}pembatalan/`,
  snapConsole: `${MASTER_DATA}snap_console/`,
  snapMesin: `${MASTER_DATA}snap_mesin/`,
  export: `${BASE_URL}export/`,
  masterData: MASTER_DATA,
  promoProxy: `${MASTER_DATA}promoProxy/`,
  whitelabel: `${MASTER_DATA}whitelabel/`,
  auth: AUTH,
};

export default routeGroup;
